var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v("* Deze data is samengesteld uit Salesforcedata")]),_c('hr'),_vm._l((_vm.keyData),function(data){return _c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(data.key))]),_c('br'),_vm._v("\n      "+_vm._s(data.data))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }